import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '~/style/theme/colors'

const Container = styled.button`
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  cursor: pointer;
  :focus {
    border: solid 3px ${props => props.theme.colors.primary};
  }
`

const SVG = styled.svg`
  cursor: pointer;
`

const colorSelection = {
  blue: colors.primary,
  white: '#FFF'
}

const CloseButton = ({ size, color, onClick }) => {
  return (
    <Container onClick={onClick}>
      <SVG

        width={size}
        height={size}
        viewBox="0 0 22 23"
        version="1.1"
        // xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="desktop"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            id="New-flow_01_Popup03"
            transform="translate(-1398.000000, -27.000000)"
            stroke={colorSelection[color] || color}
            strokeWidth="3"
          >
            <g
              id="Group-5"
              transform="translate(1408.384776, 38.384776) rotate(-315.000000) translate(-1408.384776, -38.384776) translate(1395.384776, 25.384776)"
            >
              <path d="M13,0 L13,25" id="Line" />
              <g
                id="Line-2"
                transform="translate(13.000000, 13.000000) rotate(-270.000000) translate(-13.000000, -13.000000) translate(12.000000, 0.000000)"
              >
                <path d="M1,0 L1,25" id="Line" />
              </g>
            </g>
          </g>
        </g>
      </SVG>
    </Container>
  )
}

CloseButton.defaultProps = {
  color: 'white',
  size: '15px',
  onClick: () => {}
}

CloseButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func
}

export default CloseButton
